import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IconComponent } from '../icon/icon.component';
import { ButtonComponent } from '../button/button';

@Component({
  selector: 'lib-error',
  imports: [ButtonComponent, IconComponent],
  templateUrl: './error.component.html'
})
export class ErrorComponent {
  router = inject(Router);

  goHome(): void {
    this.router.navigate(['/']);
  }
}
